import { ConfirmationModal } from '@air/component-confirmation-modal';

export type ContentCollectionCancelAllUploadsModalProps = {
  onCancelUpload: () => void;
};

export const ContentCollectionCancelAllUploadsModal = ({
  onClose,
  onCancelUpload,
}: AirModalProps<ContentCollectionCancelAllUploadsModalProps>) => (
  <ConfirmationModal
    isOpen
    onDismiss={onClose}
    title="Cancel upload"
    description="This will affect any assets that have not been uploaded. Completed uploads will still be in the workspace."
    ctaPrimaryText="Cancel Upload"
    id="cancel-board-collection-upload"
    ctaSecondaryText="Continue Uploading"
    onConfirm={onCancelUpload}
    isDangerous
  />
);
